<template>
  <div id="expertsDetail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">应急管理专家库</p>
    <el-divider></el-divider>
    <div class="body">
      <div class="body-left">
        <Article :title="expertData.Name" :html="html"></Article>
      </div>
      <div class="body-right">
        <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'其他专家'" :titleColor="'blue'"></timeline>
      </div>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import timeline from "@/components/timeline";
import Api from "@/network.js";
import Article from '@/components/article'
export default {
  components: {
    bread,
    timeline,
    Article
  },
  name: "expertsDetail",
  async beforeRouteEnter(to, from, next) {
    let res = await Api.experts.getDetail(to.query.id);
    let LastData = await Api.index.getLast("expert_internal");
    next(vm => {
      vm.expertData = res;
      for (let item of LastData) {
        vm.timelineData.list.push({
          date: item.Date,
          content: item.Name,
          url: `/experts/detail?id=${encodeURIComponent(item.Id)}`
        });
      };
      vm.html=`现任职务：${vm.expertData.Profession}<br>
        从事方向：${vm.expertData.ResearchDirection}<br>
        联系方式：${vm.expertData.Phone}<br>
        邮箱：${vm.expertData.Email}
      `
    });
  },
  watch:{
    '$route'(){
      this.$router.go(0)
    }
  },
  data() {
    return {
      timelineData: {
        title: "最新热点",
        iconSrc: require("../../assets/experts-icon.png"),
        list: []
      },
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "应急管理专家库", routerName: "experts" }
      ],
      html:'',
      expertData: {}
    };
  }
};
</script>
  
<style lang="scss" scoped>
#expertsDetail {
  width: 75%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
}
.body {
  display: flex;
  justify-content: space-around;
  .body-left {
    width: 70%;
    margin-left: 5%;
  }
}
</style>

